<template>
    <div class="back-to-list">
      <router-link :to="{ path: to}" class="back-to-list-actionable">
        <span class="icon-arrow-back" />
        <span class="back-text">{{listTitle}}</span>
      </router-link>
    </div>
</template>

<script>
export default {
    props: {
        to: {
            type: String,
            required: true
        },
        listTitle: {
          type: String,
          default: "Brainstorming Session"
        }
    }
}
</script>

<style lang="scss" scoped>
@use '@/styles/theme.scss';

.back-to-list {
  margin-bottom: 10px;
}
.back-to-list-actionable {
  display: flex;
  align-items: center;
}
.icon-arrow-back::before {
  font-size: 24px;
  vertical-align: sub;
  color: theme.$text-secondary-color;
}

.back-text {
  font-size: 14px;
  color: theme.$text-secondary-color;
  margin-left: 5px;
  font-weight: 600;
}

.back-to-list:hover a span,
.back-to-list:hover a span::before{ 
    cursor: pointer;
    color: theme.$title-color;
}

a:hover {
    text-decoration: none;
}
</style>